import React, { useEffect, useState } from "react";
import { Box, Fab, Zoom, useTheme, useMediaQuery } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTitle } from "../hooks/useTitle";
import { SiteToolbar } from "../components/SiteToolbar";
import { Seo } from "../components/Seo";
import { HexBackground } from "./HexBackground";
import { HeroSection } from "./HeroSection";
import { GamesSection } from "./GamesSection";
import { CompetitionsSection } from "./CompetitionsSection";
import { FortuneSection } from "./FortuneSection";
import { InteractivesSection } from "./InteractivesSection";
import { ToolsSection } from "./ToolsSection";
import { ProjectsSection } from "./ProjectsSection";

import { FooterSection } from "./FooterSection";

export function Home() {
  useTitle("Scott Brown");
  const theme = useTheme();
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Seo />
      <HexBackground />
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Box
          component="header"
          sx={{
            bgcolor: "background.paper",
            borderBottom: 1,
            borderColor: "divider"
          }}
        >
          <SiteToolbar />
        </Box>
        <Box component="main" id="main-content" tabIndex={-1}>
          <HeroSection />
          <GamesSection />
          <FortuneSection />
          <CompetitionsSection />
          <InteractivesSection />
          <ToolsSection />
          <ProjectsSection />
        </Box>
        <FooterSection />
      </Box>
      <Zoom in={visible} timeout={reducedMotion ? 0 : undefined}>
        <Fab
          size="small"
          aria-label="back to top"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: reducedMotion ? "instant" : "smooth"
            })
          }
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            bgcolor: theme.palette.accent,
            color: theme.palette.background.default,
            "&:hover": { bgcolor: theme.palette.accent, opacity: 0.85 }
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>
    </>
  );
}
